import React from 'react';
import PropTypes from 'prop-types';
import ColorSelector from "../../../../gd-components/color/selector/selector";

export default function ProjectColorInList(props) {

    // const classes = Classes("gd-field-project-color", "list", props.className);

    return (
        <ColorSelector value={props.item.color}
                       type="default-26"
                       attachment="middle right"
                       targetAttachment="middle left"
                       onChange={props.onChange}
                       disabled={props.disabled} />
    );
}

ProjectColorInList.propTypes = {
    item: PropTypes.object,
    disabled: PropTypes.bool,

    onChange: PropTypes.func
}